import InputField from './InputField';
import React, { ForwardedRef, forwardRef, InputHTMLAttributes } from 'react';
import { FormikErrors, FormikHelpers, useFormik } from 'formik';
import { isRequiredField } from '@/src/lib/utils/form-helpers';
import * as Yup from 'yup';

interface FormikInputField extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
  success?: string;
  textarea?: boolean;
  hideLabel?: boolean;
  description?: string;
  isClearable?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: ReturnType<typeof useFormik<any>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formikValidationSchema: Yup.ObjectSchema<any>;
}

const FormikInputField = forwardRef(
  <T,>(
    { name, formik, required, formikValidationSchema, ...otherProps }: FormikInputField,
    _: ForwardedRef<FormikHelpers<unknown>>,
  ) => {
    const getError = (input: string | FormikErrors<T>) => (Array.isArray(input) ? input[0] : input);
    const error =
      !!formik.errors[name] && !!formik.touched[name]
        ? getError(formik.errors[name] as string | FormikErrors<T>)
        : undefined;

    const isRequired = required || isRequiredField(formikValidationSchema, name);

    return (
      <InputField
        name={name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values[name]}
        error={error}
        requiredLabel={isRequired}
        required={isRequired}
        aria-required={isRequired}
        hideLabel={otherProps.hideLabel}
        {...otherProps}
      />
    );
  },
);
FormikInputField.displayName = 'FormikInputField';

export default FormikInputField;
